// src/App.js
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import Seo from './components/Seo';
import ScrollToTop from './ScrollToTop';
// The landing page loads eagerly: lazy-loading it leaves a blank main
// while its chunk fetches on first visit — the worst page to do that on.
import Home from './pages/Home';
import './App.css';

const DojiPad = lazy(() => import('./pages/DojiPad'));
const DojiPadInstitutional = lazy(() => import('./pages/DojiPadInstitutional'));
const WorkWithUs = lazy(() => import('./pages/WorkWithUs'));
const Licensing = lazy(() => import('./pages/Licensing'));
const QuantNexus = lazy(() => import('./pages/QuantNexus'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Seo />
        <div className="app-container">
          <Header />
          <main className="main-content">
            <Suspense fallback={null}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/work-with-us" element={<WorkWithUs />} />
                <Route path="/licensing" element={<Licensing />} />
                <Route path="/quantnexus" element={<QuantNexus />} />
                <Route path="/dojipad" element={<DojiPad />} />
                <Route path="/dojipad-institutional" element={<DojiPadInstitutional />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />

                {/* Retired routes. Netlify serves real 301s (netlify.toml);
                    these cover client-side navigation and local dev. */}
                <Route path="/industries/*" element={<Navigate to="/work-with-us" replace />} />
                <Route path="/services/*" element={<Navigate to="/work-with-us" replace />} />
                <Route path="/ai-ml-engineering" element={<Navigate to="/work-with-us" replace />} />
                <Route path="/fintech-innovation" element={<Navigate to="/work-with-us" replace />} />
                <Route path="/research-development" element={<Navigate to="/work-with-us" replace />} />
                <Route path="/servicecalculator" element={<Navigate to="/work-with-us" replace />} />
                <Route path="/news" element={<Navigate to="/quantnexus" replace />} />
                <Route path="/news/*" element={<Navigate to="/quantnexus" replace />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
